//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'rb-header-promo-stripe',
  props: {
    color: String, // options: ['black', 'light-grey', 'rayban-red', 'white', 'medium-grey', 'dark-grey', 'success', 'neutral']
    /*
     * Image Props
     */
    imageDesktop: String,
    imageTablet: String,
    imageMobile: String,
    // TODO: CHECK IF WE NEED IMAGE ALT TEXT
    imageAlt: String,
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    backgroundStyle() {
      if (this.isMobile) {
        return this.imageMobile ? `background: url(${this.imageMobile})` : ''
      }
      if (this.isTablet) {
        return this.imageTablet ? `background: url(${this.imageTablet})` : ''
      }
      return this.imageDesktop ? `background: url(${this.imageDesktop})` : ''
    },
    promoStripeColorClass() {
      return this.color ? `promo-stripe--${this.color}` : ''
    },
    isMobile() {
      return this.$mq === MOBILE
    },
    isTablet() {
      return this.$mq === TABLET
    },
  },
  methods: {
    onPromoStripeClick() {
      // TODO: add logic
    },
  },
}
